export default __webpack_public_path__ + "static/travelsandbox-from-freshcells-as-driver-for-hlx-touristik-business-model-2d5a5f86f96645adc8417a71552cc763.jpg";